import { render, staticRenderFns } from "./CorpTube.vue?vue&type=template&id=d20045c6&scoped=true&"
import script from "./CorpTube.vue?vue&type=script&lang=ts&"
export * from "./CorpTube.vue?vue&type=script&lang=ts&"
import style0 from "./CorpTube.vue?vue&type=style&index=0&id=d20045c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20045c6",
  null
  
)

export default component.exports